/**
 * 取引ステータス
 */
export type DealStatus =
  | "1" // 下書き、期限切れ
  | "2" // 受注待ち
  | "3" // レビュー中
  | "4" // 確認
  | "5" // 完了
  | "6";// 未承認

/** 取引ステータス：下書き、期限切れ */
export const Draft = "1" as DealStatus;
/** 取引ステータス：受注待ち */
export const Pending = "2" as DealStatus;
/** 取引ステータス：レビュー中 */
export const InReview = "3" as DealStatus;
/** 取引ステータス：確認 */
export const Confirmation = "4" as DealStatus;
/** 取引ステータス：完了 */
export const Completed = "5" as DealStatus;
/** 取引ステータス：未承認 */
export const Unapproved = "6" as DealStatus;
